import { Component } from '@angular/core';
import { BookFeatureActivationService } from '../../../services/book-feature-activation.service';
import { CommunicationService } from '../../../services/communication.service';
import { ApplicationStateService } from '../../../services/application-state.service';

@Component({
    selector: 'app-feature-menu',
    templateUrl: './feature-menu.component.html',
    styleUrls: ['./feature-menu.component.scss'],
    standalone: true
})
export class FeatureMenuComponent {

    constructor(public applicationStateService: ApplicationStateService,
                public bookFeatureActivationService: BookFeatureActivationService,
                private communicationService: CommunicationService) {
    }

    toggleReadspeaker($event, closeMenu?: boolean): void {
        if (!closeMenu) {
            $event.stopPropagation();
        }
        this.bookFeatureActivationService.readspeakerActivated = !this.bookFeatureActivationService.readspeakerActivated;
        this.bookFeatureActivationService.readspeakerElementsVisible = !this.bookFeatureActivationService.readspeakerElementsVisible;
        this.communicationService.toggleReadspeakerVisibility();
    }

    toggleNotes($event, closeMenu?: boolean): void {
        if (!closeMenu) {
            $event.stopPropagation();
        }
        this.bookFeatureActivationService.rectsVisible = !this.bookFeatureActivationService.rectsVisible;
        this.bookFeatureActivationService.textSelectionsVisible = !this.bookFeatureActivationService.textSelectionsVisible;
        if (this.bookFeatureActivationService.textSelectionsVisible) {
            this.communicationService.announceHighlightTextboxes();
        }

    }

    toggleVideosAudiosAndInteractiveTasks($event, closeMenu?: boolean): void {
        if (!closeMenu) {
            $event.stopPropagation();
        }
        this.bookFeatureActivationService.interactiveTasksVisible = !this.bookFeatureActivationService.interactiveTasksVisible;
        this.bookFeatureActivationService.videosVisible = !this.bookFeatureActivationService.videosVisible;
        this.bookFeatureActivationService.audiosVisible = !this.bookFeatureActivationService.audiosVisible;
        this.bookFeatureActivationService.linksVisible = !this.bookFeatureActivationService.linksVisible;
        this.communicationService.announceDetectChanges();
    }

    toggleDrawings($event, closeMenu?: boolean): void {
        if (!closeMenu) {
            $event.stopPropagation();
        }
        this.bookFeatureActivationService.pageDrawingsVisible = !this.bookFeatureActivationService.pageDrawingsVisible;
    }
}
